import React from 'react'
import { AutoComplete } from 'app/maps'

const theme = {
  div: null,
  label: 'label block mb-2',
  input: 'input-basic',
  error: 'text-sm text-red-600 mt-1',
}

export default function Address(props) {
  const {
    types,
    value,
    onChange,
    className,
    classNames,
    divProps,
    label,
    labelProps,
    error,
    errorProps,
    ...inputProps
  } = props

  const styles = { ...theme, ...classNames }

  return (
    <div className={styles.div} {...divProps}>
      {label && (
        <label className={styles.label} {...labelProps}>
          {label}
        </label>
      )}
        <AutoComplete
          types={types}
          onPlaceChanged={address => {
            onChange && onChange(address)
          }}
        >
          <input
            type="text"
            {...inputProps}
            className={[styles.input, className]}
            value={onChange ? value?.street || '' : value?.street}
            onChange={event => {
              onChange && onChange({
                ...value,
                location: null, 
                display_name: null, 
                formatted: null,
                google_id: null,
                street: event.target.value,
              })
            }}
          />
        </AutoComplete>
      {error && (
        <div className={styles.error}>
          {error}
        </div>
      )}
    </div>
  )
}
